import React, { useState } from "react";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";

/**
 * e.target.value
 */

function TimePickerGPT0({
  label,
  value = "",
  mandatory = false,
  onChange,
  className = "",
  autoComplete = "off",
  transparent = true,
  onEnter = () => {},
  focusOnStart = false,
  disabled = false,
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onEnter(); // Execute the provided onEnter action
    }
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [time, setTime] = useState(value ? dayjs(value).format("HH:mm") : "");
  const [not_valid, setNotValid] = useState(false);
  const handleChange = (e) => {
    let val = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    if (val.length > 4) val = val.slice(0, 4); // Limit to 4 characters

    // Auto-insert `:` when there are at least 2 digits
    if (val.length >= 3) {
      val = `${val.slice(0, 2)}:${val.slice(2)}`;
    }

    setTime(val); // Update field value immediately

    // Validate only when full "HH:mm" is entered
    if (val.length === 5) {
      let parsedTime = dayjs(val, "HH:mm", true);
      if (parsedTime.isValid()) {
        setNotValid(false);

        // Round minutes to the nearest 15-minute slot
        let minutes = parsedTime.minute();
        let roundedMinutes = Math.round(minutes / 15) * 15;

        // Ensure we don't go over 60 minutes
        if (roundedMinutes === 60) {
          parsedTime = parsedTime.add(1, "hour").minute(0);
        } else {
          parsedTime = parsedTime.minute(roundedMinutes);
        }
        let hours = parsedTime.hour();
        if (hours === 24) {
          hours = 0;
        }
        if (hours < 8) {
          setNotValid(true);
          handleClickVariant("L'heure doit être entre 8h et 20h", "error");
          // set to 8h
          parsedTime = parsedTime.hour(8);
          setTime(parsedTime.format("HH:mm"));
          onChange && onChange(parsedTime);
          return;
        }
        if (hours > 20) {
          setNotValid(true);
          handleClickVariant("L'heure doit être entre 8h et 20h", "error");
          // set to 20h
          parsedTime = parsedTime.hour(20);
          setTime(parsedTime.format("HH:mm"));
          onChange && onChange(parsedTime);
          return;
        }

        // Update state with rounded time
        const roundedTimeString = parsedTime.format("HH:mm");
        setTime(roundedTimeString);
        onChange && onChange(parsedTime);
      } else {
        setNotValid(true);
      }
    } else {
      setNotValid(true);
      onChange && onChange(null); // Partial input is ignored
    }
  };

  return (
    <div className={`w-full ${className}`}>
      {/* Label */}

      {/* Input Field */}
      <input
        disabled={disabled}
        type="text"
        placeholder="HH:mm"
        value={time}
        autoFocus={focusOnStart}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        autoComplete={autoComplete}
        className={`
          w-full
          h-8
          px-2
          py-1
          rounded-xl
          border
          ${mandatory && !value ? "border-red-500" : "border-gray-300"}
          ${not_valid ? "text-red-500" : ""}
          border-gray-300
          focus:border-2 focus:border-blue-300
          outline-none
          transition
          ease-in-out
          duration-150
          ${
            disabled
              ? "bg-neutral-100 text-shadow_25"
              : transparent
              ? "bg-transparent"
              : "bg-white"
          }      
        `}
        style={{
          fontSize: "14px",
        }}
      />
    </div>
  );
}

export default TimePickerGPT0;
